import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { usePartnerAuth } from '../hooks/usePartnerAuth';

/**
 * Protected route for Partner pages
 * Requires valid Partner API key in localStorage
 */
export default function PartnerProtectedRoute() {
  const { isPartner, isLoading } = usePartnerAuth();
  const location = useLocation();

  console.log('🔑 PartnerProtectedRoute:', { isPartner, isLoading });

  if (isLoading) {
    console.log('⏳ Verifying partner access...');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying partner access...</p>
        </div>
      </div>
    );
  }

  if (!isPartner) {
    console.log('❌ No valid partner API key, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('✅ Partner access granted!');
  return <Outlet />;
}
